export default __webpack_public_path__ + "static/media/it-for-kids.d28fb963.png";